<div class="tenant-settings-component scroll-container" style="max-height: calc(100vh - 122px);">
  @if (tenant) {
    <!-- Tabs -->
    <ul class="nav nav-tabs card-tabs" style="flex-wrap: nowrap; overflow-x: auto; overflow-y: hidden;">
      <li class="nav-item" [class.active]="currentTab === 'general'" (click)="switchTab('general')">
        <a class="nav-link pointer" [class.active]="currentTab === 'general'"><span i18n="@@components.tenant_settings.tabs.general">General</span></a>
      </li>
      <li class="nav-item" [class.active]="currentTab === 'security'" (click)="switchTab('security')">
        <a class="nav-link pointer" [class.active]="currentTab === 'security'"><span i18n="@@components.tenant_settings.security">Security</span></a>
      </li>
      <li class="nav-item" [class.active]="currentTab === 'hierarchy'" (click)="switchTab('hierarchy')">
        <a class="nav-link pointer" [class.active]="currentTab === 'hierarchy'"><span i18n="@@components.tenant_settings.hierarchy">Hierarchy</span></a>
      </li>
      <li class="nav-item" [class.active]="currentTab === 'users'" (click)="switchTab('users')">
        <a class="nav-link pointer" [class.active]="currentTab === 'users'"><span i18n="@@common.users">Users</span></a>
      </li>
    </ul>
    <!-- Tabs end -->

    <div class="row mt-3">
      <div class="col">
        <div class="row">

          <!-- General -->
          @if (currentTab === 'general') {
            <div class="col-sm-12">
              <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-baseline flex-wrap gap-2">
                  <span>{{ tenant.name }}</span>
                  <span class="fw-normal">
                    <default-dates [created_at]="tenant.created_at" [updated_at]="tenant.updated_at"></default-dates>
                  </span>
                </div>
                <div class="card-body" [checkPermissions]="{ roles:['admin', 'support', 'sales'], permissions: ['owner'] }">
                  <h3 class="section-title mb-3" i18n="@@components.tenant_settings.brand">Brand</h3>
                  <tenant-settings-brand-theme></tenant-settings-brand-theme>
                </div>
              </div>
            </div>
          }
          <!-- General end -->

          <!-- Security -->
          @if (currentTab === 'security') {
            <div class="col-sm-12">
              <div class="card mb-3">
                <div class="card-header" i18n="@@components.tenant_settings.authentication_policy">Authentication policy</div>
                <div class="card-body">
                  <pdc-authentication-policy [tenant]="tenant"></pdc-authentication-policy>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="card mb-3">
                <div class="card-header" i18n="@@components.tenant_settings.access_control">Access control</div>
                <div class="card-body">
                  <div class="mb-1">
                    <strong i18n="@@components.tenant_settings.support_access">Support access</strong>:
                    @if (tenant.secured) {
                      <span i18n="@@components.tenant_settings.support_access_restricted">restricted (opted out)</span>
                    } @else {
                      <span i18n="@@components.tenant_settings.support_access_allowed">allowed</span>
                    }
                  </div>
                  <div>
                    <strong i18n="@@components.platform_form.allowed_ip_addresses">Allowed ip addresses</strong>:
                    {{ tenant.allowed_ip_addresses?.length ? tenant.allowed_ip_addresses.join(', ') : '—' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12" [checkPermissions]="{ roles:['admin', 'support', 'sales'], permissions: ['admin', 'owner'] }">
              <div class="card mb-3">
                <div class="card-header" i18n="@@components.tenant_settings.url_integration">Url Integration</div>
                <div class="card-body">
                  <url-integration [tenant]="tenant"></url-integration>
                </div>
              </div>
            </div>
          }
          <!-- Security end -->

          <!-- Hierarchy -->
          @if (currentTab === 'hierarchy') {
            <div class="col-sm-12" [checkPermissions]="{ roles:['admin', 'support', 'sales'], permissions: ['admin', 'owner'] }">
              <div class="card mb-3">
                <div class="card-header" i18n="@@components.tenant_settings.hierarchy">Hierarchy</div>
                <div class="card-body">
                  @if (tenant.super_tenant_id) {
                    <super-tenant [tenant]="tenant"></super-tenant>
                  }
                  <sub-tenants [currentTenant]="tenant"></sub-tenants>
                </div>
              </div>
            </div>
          }
          <!-- Hierarchy end -->

          <!-- Users -->
          @if (currentTab === 'users') {
            <!-- Invites -->
            <div class="col-sm-12">
              <div class="card mb-3">
                <div class="card-header">
                  <div class="row">
                    <div class="col" i18n="@@common.user_invites">User Invites</div>
                    <div class="col text-end">
                      <button (click)="openInviteUserModal()" class="btn btn-xs btn-dark" i18n="@@components.tenant_settings.invite_user">Invite user</button>
                    </div>
                  </div>
                </div>
                <div class="card-body p-0">
                  @if (invites && invites.length > 0) {
                    <div class="table-responsive-new scroll-horizontal">
                      <table class="table-new">
                        <thead class="table-dark">
                          <tr>
                            <th><div i18n="@@common.email">Email</div></th>
                            <th class="text-nowrap"><div><fa-icon [icon]="['fas', 'upload']" transform="shrink-2" [fixedWidth]="true"></fa-icon> <span i18n="@@common.created">Created</span></div></th>
                            <th class="text-nowrap"><div><fa-icon [icon]="['fas', 'sync-alt']" transform="shrink-2" [fixedWidth]="true"></fa-icon> <span i18n="@@common.updated">Updated</span></div></th>
                            <th><div i18n="@@common.permissions">Permissions</div></th>
                            <th><div></div></th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (invite of invites; track invite) {
                            <tr>
                              <td class="text-nowrap">
                                <a href="mailto:{{ invite.email }}" class="unmarked" tooltip="Send email to {{ invite.email }}" container="body">
                                  <fa-icon [icon]="['fas', 'envelope']" transform="shrink-2" [fixedWidth]="true"></fa-icon>
                                  <strong>{{ invite.email }}</strong>
                                </a>
                              </td>
                              <td class="text-nowrap">
                                <fa-icon [icon]="['fas', 'upload']" transform="shrink-2" [fixedWidth]="true" tooltip="{{ invite.created_at | pdcDate: { precision: 'm' } }}" container="body"></fa-icon>
                                <span [dateFromNow]="invite.created_at" [precision]="'m'"></span>
                              </td>
                              <td class="text-nowrap">
                                <fa-icon [icon]="['fas', 'sync-alt']" transform="shrink-2" [fixedWidth]="true" tooltip="{{ invite.updated_at | pdcDate: { precision: 'm' } }}" container="body"></fa-icon>
                                <span [dateFromNow]="invite.updated_at" [precision]="'m'"></span>
                              </td>
                              <td>@for (permission of getProductPermissions(invite.permissions); track permission) {
                                <span class="badge rounded-pill text-bg-light me-1">{{ permissions[permission] }}</span>
                              }</td>
                              <td class="align-middle btn-cell text-nowrap">
                                <div class="d-flex justify-content-end gap-1 flex-wrap">
                                  @if (checkEditorsPermission(invite.permissions)) {
                                    <button type="button" class="btn btn-xs btn-danger" (click)="cancelInvitation(invite.id)" i18n-tooltip="@@components.tenant_settings.cancel_invitation" tooltip="Cancel invitation" container="body">
                                      <fa-icon [icon]="['fas', 'user-times']" [fixedWidth]="true"></fa-icon>
                                    </button>
                                  }
                                  <button type="button" class="btn btn-xs btn-dark" (click)="resendInviteNotification(invite.id)" i18n-tooltip="@@components.tenant_settings.resend_invitation_link" tooltip="Resend invitation link" container="body">
                                    <fa-icon [icon]="['fas', 'paper-plane']" [fixedWidth]="true"></fa-icon>
                                  </button>
                                  <button type="button" class="btn btn-xs btn-dark px-3" (click)="openEditInvitePermissionsModal(invite)" i18n-tooltip="@@components.tenant_settings.edit_permissions" tooltip="Edit permissions" container="body">
                                    <fa-icon [icon]="['fas', 'pen']" [fixedWidth]="true"></fa-icon>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  }
                </div>
              </div>
            </div>
            <!-- Invites end -->

            <!-- Users -->
            @if (tenant.roles?.length > 0) {
              <div class="col-sm-12">
                <div class="card mb-3">
                  <div class="card-header" i18n="@@common.users">Users</div>
                  <div class="card-body p-0">
                    <div class="table-responsive-new scroll-horizontal">
                      <table class="table-new">
                        <thead class="table-dark">
                          <tr>
                            <th><div i18n="@@common.name">Name</div></th>
                            <th class="text-nowrap"><div><fa-icon [icon]="['fas', 'upload']" transform="shrink-2" [fixedWidth]="true"></fa-icon> <span i18n="@@common.created">Created</span></div></th>
                            <th class="text-nowrap"><div><fa-icon [icon]="['fas', 'sync-alt']" transform="shrink-2" [fixedWidth]="true"></fa-icon> <span i18n="@@common.updated">Updated</span></div></th>
                            <th><div i18n="@@common.permissions">Permissions</div></th>
                            <th><div></div></th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (role of tenant.getRolesWithUsers(); track role) {
                            <tr [class.dim]="role.user?.disabled">
                              <td class="text-nowrap">
                                <strong tooltip="#{{ role.user?.id }}" container="body">{{ role.user?.name }}</strong><br>
                                <a href="mailto:{{ role.user?.email }}" class="unmarked small" tooltip="Send email to {{ role.user?.email }}" container="body">
                                  <fa-icon [icon]="['fas', 'envelope']" transform="shrink-2" [fixedWidth]="true"></fa-icon>
                                  {{ role.user?.email }}
                                </a>
                              </td>
                              <td class="text-nowrap">
                                <fa-icon [icon]="['fas', 'upload']" transform="shrink-2" [fixedWidth]="true" tooltip="{{ role.created_at | pdcDate: { precision: 'm' } }}" container="body"></fa-icon>
                                <span [dateFromNow]="role.created_at" [precision]="'m'"></span>
                              </td>
                              <td class="text-nowrap">
                                <fa-icon [icon]="['fas', 'sync-alt']" transform="shrink-2" [fixedWidth]="true" tooltip="{{ role.updated_at | pdcDate: { precision: 'm' } }}" container="body"></fa-icon>
                                <span [dateFromNow]="role.updated_at" [precision]="'m'"></span>
                              </td>
                              <td>@for (permission of getProductPermissions(role.permissions); track permission) {
                                <span class="badge rounded-pill text-bg-light me-1">{{ permissions[permission] }}</span>
                              }</td>
                              <td class="align-middle btn-cell text-nowrap nodim">
                                <div class="d-flex justify-content-end gap-1 flex-wrap">
                                  @if (role.user_id !== currentUserId && checkEditorsPermission(role.permissions)) {
                                    <button type="button" class="btn btn-xs btn-danger" (click)="openRemoveUserModal(role)" i18n-tooltip="@@components.tenant_settings.remove_user" tooltip="Remove User" container="body">
                                      <fa-icon [icon]="['fas', 'user-times']" [fixedWidth]="true"></fa-icon>
                                    </button>
                                  }
                                  <button type="button" class="btn btn-xs btn-dark px-3" (click)="openEditRolePermissionsModal(role)" i18n-tooltip="@@components.tenant_settings.edit_permissions" tooltip="Edit permissions" container="body">
                                    <fa-icon [icon]="['fas', 'pen']" [fixedWidth]="true"></fa-icon>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            }
            <!-- Users end -->
          }
          <!-- Users tab end -->

        </div>
      </div>
    </div>
  } @else {
    <div class="alert alert-warning" i18n="@@common.no_result">No result</div>
  }
</div>
